import { render, staticRenderFns } from "./ElImage.vue?vue&type=template&id=4845fa5e"
import script from "./ElImage.vue?vue&type=script&lang=js"
export * from "./ElImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports